import {InvItemCustomButton} from "./InvItemCustomButton";
import * as ItemButtonLevel from "../../constants/ItemButtonLevel";
import {getName, translateMessage} from "../../common/Translator";

export class InvItemCustomPanel {
    constructor(container, customSearcherWindow, dialog) {
        let that = this;
        that.levelsContainer = container.find("#buttonsContainer");
        that.breadCrumbs = container.find("#breadcrumb");
        that.searchingPart = container.find("#searching");
        that.currentBreadCrumbLevel = 0;
        that.customSearcherWindow = customSearcherWindow;
        that.breadCrumbs.initBreadcrumb({
            levels: 1
        });
        let breadCrumbsHomeLink = $(that.breadCrumbs.find("li")[0]).find("a");
        breadCrumbsHomeLink.attr("id", 1);
        breadCrumbsHomeLink.text("");
        breadCrumbsHomeLink.append(`<i class="fa fa-home"></i>`);
        that.dialog = dialog;
    }

    setHeights() {
        let that = this;
        let window = $("#window" + that.dialog.elementId);
        let windowHeight = window.height();
        let breadCrumbHeight = that.breadCrumbs.height();
        let footerHeight = window.find(".searcherWindowBtns").height();
        let height = windowHeight - breadCrumbHeight - footerHeight - 25;
        that.levelsContainer.height(height);
        that.searchingPart.height(height);
        that.searchingPart.css("display", "none");
    }

    setGridHeight() {
        let that = this;
        let rootElement = that.searchingPart;
        let height = rootElement.height();
        let criteriaWidgetHeight = rootElement.find(`#listScreenFiltering`).outerHeight(true);
        let searchParamsHeight = rootElement.find(`#searchParams`).outerHeight(true);
        let searchInputHeight = rootElement.find(`.searchInput`).outerHeight(true);
        let newHeight = height - rootElement.find(".searcherWindowBtns").height() - criteriaWidgetHeight - searchParamsHeight - searchInputHeight - 10;
        rootElement.find("#grid").height(newHeight);
    }

    addBasicPanel(itemLevels, level, record) {
        let that = this;
        that.currentBreadCrumbLevel++;
        let panel = $(`<div id = ${that.currentBreadCrumbLevel}></div>`);
        that.levelsContainer.append(panel);
        if (!level)
            level = ItemButtonLevel.Level1;
        for (let itemLevel of itemLevels) {
            new InvItemCustomButton(itemLevel, level, record, panel, that);
        }
        that.addBreadCrumbItem();
    }

    addPanel(favouriteItem, records, nextLevel) {
        let that = this;
        that.currentBreadCrumbLevel++;
        that.levelsContainer.find("div").css("display", "none");
        that.removeNoRecordsMsgIfExist();
        let panel = $(`<div class = "fullHeight customSearchPanel" id = ${that.currentBreadCrumbLevel}></div>`);
        that.levelsContainer.append(panel);
        for (let record of records) {
            new InvItemCustomButton(favouriteItem, nextLevel, record, panel, that);
        }
    }

    addBreadCrumbItem(currentRecord) {
        let that = this;
        that.breadCrumbs.find("li").filter((i) => $($(this.breadCrumbs.find("li")[i]).find("a")).attr("id") > that.currentBreadCrumbLevel).remove();
        let breadCrumbItem = $(that.breadCrumbs.find("li")[0]);
        if (currentRecord)
            breadCrumbItem = $(`<li><a href="#" id = ${that.currentBreadCrumbLevel}>${getName(currentRecord.name1, currentRecord.name2)}</a></li>`);
        breadCrumbItem.on("click", (e) => {
            e.preventDefault();
            let target = $(e.target);
            if (!target.is("a"))
                target = target.closest("a");
            let currentId = target.attr("id");
            if (currentId == that.currentBreadCrumbLevel)
                return;
            that.levelsContainer.css("display", "block");
            that.levelsContainer.find("div").css("display", "none");
            that.searchingPart.css("display", "none");
            that.levelsContainer.find("div").filter((i) =>
                $(this.levelsContainer.find("div")[i]).attr("id") > currentId).remove();
            that.breadCrumbs.find("li").filter((i) => $($(this.breadCrumbs.find("li")[i]).find("a")).attr("id") > currentId).remove();
            that.removeNoRecordsMsgIfExist();
            that.levelsContainer.find("div#" + currentId).css("display", "block");
            that.currentBreadCrumbLevel = currentId;
        });
        that.breadCrumbs.find("ul").append(breadCrumbItem);

    }

    removeNoRecordsMsgIfExist() {
        let that = this;
        that.levelsContainer.find(`#${that.currentBreadCrumbLevel}msg`).remove();
    }

    addNoRecordsToShowMsg(currentRecord, searchInKlass) {
        let that = this;
        let msg = $(`<h4 class = "fullHeight customSearchMsg" id = ${that.currentBreadCrumbLevel}msg>${translateMessage("There is no {0} for {1}", searchInKlass, getName(currentRecord.name1, currentRecord.name2))}</h4>`);
        that.levelsContainer.find("div#" + that.currentBreadCrumbLevel).append(msg);
    }
}